import { createContext, useContext } from 'react'

export const ScaleContext = createContext<'sm' | 'lg'>('sm')
export const useScale = () => useContext(ScaleContext)
